import { AxiosRequestConfig } from "axios";

import { InterceptorRequestHandler } from "@api/interceptors/types";
import authService from "@lib/services/AuthService";
import LogTraceIdService from "@lib/services/LogTraceIdService";

export const requestConfigInterceptor: InterceptorRequestHandler = (config: AxiosRequestConfig) => {
  const token = authService.getAccessToken();
  const userRole = authService.getDefaultRole();
  const xRequestId = LogTraceIdService.generateXRequestId();

  // Config Headers
  if (token) {
    config.headers = {
      Authorization: `Bearer ${token}`,
      "Current-Role": userRole,
    };
  }

  // Attach X-Request-Id to the request headers no matter if authorized or not.
  config.headers = {
    ...config.headers,
    "X-Request-Id": xRequestId,
  };

  return config;
};
